import React, { useState, useRef, useEffect } from 'react'
import { useSpring, animated, config } from 'react-spring'

import { domService } from '../common/services/dom.service'
import { httpService } from '../common/services/http.service'
import { TocList } from './toc-list'
import { Overlay } from '../common/components/overlay'
import { NAVBAR_WIDTH } from '../common/components/navbar-layout.style'
import { REPORT_VIEWER_MODE } from './constants'

import { useStyles } from './toc-menu.style'
import { ExecutiveSummaryLink } from './executive-summary-link'

export const TocMenu = function ({ report, mode }) {
  const classes = useStyles()
  const tocRef = useRef()
  const scrollableDiv = useRef()
  const [isTocVisible, setIsTocVisible] = useState(false)
  const tocCssProps = useSpring({ left: isTocVisible ? 0 : -600, config: { ...config.stiff, clamp: true } })

  function handleTocClick () {
    setIsTocVisible(!isTocVisible)
  }

  function handleOverlayClick () {
    setIsTocVisible(false)
  }

  useEffect(() => {
    if (!scrollableDiv.current) {
      scrollableDiv.current = domService.getClosestScrollableParent(tocRef.current.parentNode)
    }

    if (scrollableDiv.current) {
      scrollableDiv.current.style.overflowY = isTocVisible ? 'hidden' : 'auto'
    }

    return () => {
      if (scrollableDiv.current) {
        scrollableDiv.current.style.overflowY = 'auto'
      }
    }
  }, [isTocVisible])

  function getLeftPosition () {
    const isSafari = (navigator.userAgent.indexOf('Safari') !== -1) && (navigator.userAgent.indexOf('Chrome') === -1)

    if (httpService.isStandalone) {
      return 0
    }

    return (mode === REPORT_VIEWER_MODE.READ || isSafari) ? NAVBAR_WIDTH : 0
  }

  return (
    <>
      <div ref={tocRef} className={classes.tocMenuFloat} style={{ left: getLeftPosition() }}>
        <div className={classes.centerVertically}>
          <a className={classes.tocMenuButton} onClick={handleTocClick} data-qa="open-toc-menu-button">
            <div className={classes.tocMenuIcon}></div>
            <div className={classes.tocMenuLabel}>Table of Contents</div>
          </a>
        </div>
        <div className={classes.centerVertically}>
          <animated.div className={classes.tocListContainer} style={tocCssProps}>
            <div className={classes.executiveSummaryLink}>
              <ExecutiveSummaryLink report={report} />
            </div>
            <a className={classes.close} onClick={handleOverlayClick} data-qa="close-toc-menu-button"></a>
            <TocList report={report} className={classes.tocList} filteredToc={report.groups.filter((group) => !!group.id)} />
          </animated.div>
        </div>
      </div>
      {isTocVisible &&
        <Overlay onClick={handleOverlayClick} />
      }
    </>
  )
}
